import React, { useState, useRef, useEffect } from 'react';
import { Card, Stack, Typography } from '@mui/joy';
import { DescriptionTwoTone } from '@mui/icons-material';
import { getApiUrl } from '../utils/api';

function DragAndDrop({ model, user, msg }) {
    const [files, setFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState(
        model.files.split(',').map(url => url.trim()).filter(url => url !== '')
    );
    const fileInputRef = useRef(null);

    useEffect(() => {
        setFiles([]);
        setUploadedFiles(
            model.files.split(',').map(url => url.trim()).filter(url => url !== '')
        );
    }, [model]);

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);
        handleFiles(droppedFiles);
    };

    const handleFileSelect = (event) => {
        const selectedFiles = Array.from(event.target.files);
        handleFiles(selectedFiles);
    };

    const handleFiles = (fileList) => {
        const totalFiles = uploadedFiles.length;

        if (totalFiles > 4) {
            alert('You cannot upload more than 5 files in total.');
            return;
        }

        fileList.forEach((file) => {
            const fileURL = getApiUrl(`/v3/cloud/storage/get/${file.name}`);

            if (!uploadedFiles.includes(fileURL) && !files.includes(file)) {
                setFiles((prevFiles) => [...prevFiles, file]);
                uploadFile(file);
            }
        });
    };

    const handleClick = () => {
        fileInputRef.current.click();
    };

    const uploadFile = async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        try {
            const uploadResponse = await fetch(getApiUrl('/v3/cloud/storage/upload'), {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${user.jwt_token}`,
                },
                body: formData,
            });

            if (uploadResponse.ok) {
                const responseData = await uploadResponse.json();
                const fileURL = getApiUrl(`/v3/cloud/storage/get/${responseData.data.fileName}`);

                setUploadedFiles((prevFiles) => [...prevFiles, fileURL]);

                model.files += model.files.length > 0 ? `,${fileURL}` : fileURL;
                console.log('Upload successful:', fileURL);
            } else {
                console.error('Upload failed:', uploadResponse.statusText);
            }
        } catch (error) {
            console.error('Error uploading file:', error);
        }
    };

    return (
        <>
            <Card
                onClick={handleClick}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                sx={{
                    mt: 1,
                    height: '200px',
                    borderRadius: 20,
                    border: '2px dashed #8e24aa',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                }}
            >
                <Typography level='body-md'>{msg}</Typography>
            </Card>

            <Stack spacing={2} sx={{ mt: 2 }}>
                {uploadedFiles.map((file, index) => (
                    <Card key={index} sx={{ borderColor: "#573173", borderRadius: 20 }}>
                        <Stack direction="row" spacing={2} sx={{ alignItems: "center", mr: 2 }}>
                            <Card sx={{ p: 1.4, backgroundColor: "#573173" }} variant='soft'>
                                <DescriptionTwoTone />
                            </Card>
                            <Stack spacing={0.1}>
                                <Typography level='title-md'>{file.replace("https://api.screwltd.com/v3/cloud/storage/get/", "").slice(37).replaceAll("%20", " ")}</Typography>
                            </Stack>
                        </Stack>
                    </Card>
                ))}
            </Stack>

            <input
                ref={fileInputRef}
                type="file"
                multiple
                accept="application/pdf"
                onChange={handleFileSelect}
                style={{ display: 'none' }}
            />
        </>
    );
}

export default DragAndDrop;
